import { createGlobalStyle } from 'styled-components';

const NotificationGlobalStyle = createGlobalStyle`
    body {
        .ant-notification-notice.default-theme-toast,
        .ant-notification-notice.default-theme-banner {
            width: auto;
            padding: 10px 16px;

            .ant-notification-notice-icon {
                margin-left: 0;
                line-height: 20px;
            }

            .ant-notification-notice-message {
                margin-bottom: 0;
                margin-left: 24px;
                padding-right: 0;
                font-size: 14px;
                white-space: nowrap;
            }

            .ant-notification-notice-close {
                right: 16px;
            }
        }

        .ant-notification-notice.default-theme-toast.default-theme-toast-loading {
            .ant-notification-notice-icon {
                padding-top: 3px;
            }
        }
    }
`;

export default NotificationGlobalStyle;
